enum RobotGeneration {
  GEN_0 = "0",
  GEN_1 = "1",
  GEN_2 = "2",
  GEN_P0 = "P0",
  GEN_P1 = "P1",
}

export default RobotGeneration;
